import { BaseEnum } from "../BaseEnum";

export class BalanceDeposited extends BaseEnum {
  static NOT_DEPOSITED = 1;
  static DEPOSITED = 2;

  static Codes = [this.NOT_DEPOSITED, this.DEPOSITED];
  static _labelKeys = ["not-deposited", "deposited"];
}
